import * as React from 'react';
import { toast } from '../../redux/message/actions';
import C from 'react-clipboard.js';
import { useDispatch } from 'react-redux';
import { useCallback } from 'react';

export interface ClipboardProps {
  content: string;
  className?: string;
  message?: string;
}

export function Clipboard({ content, className, message, children }: React.PropsWithChildren<ClipboardProps>) {
  const dispatch = useDispatch();

  const onSuccess = useCallback(() => {
    dispatch(toast({ type: 'info', title: message || 'Copied to clipboard' }));
  }, [dispatch, message]);

  return (
    <C className={className} component="div" data-clipboard-text={content} onSuccess={onSuccess}>
      {children as any}
    </C>
  );
}
